import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const API = () => global.config.apiDomain + '/mc-user/web/admin/bot-flag';

// isBot chặn nick nhận mưa quà, thưởng nhiệm vụ, lì xì icoin và quà may mắn (farm auto click).
export default class BotFlagManagerPage extends Component {
    state = { uid: '', account: null, bots: [], cursor: null, hasMore: true, loading: false };

    componentDidMount() {
        this.loadBots();
    }

    loadBots = async (reset = false) => {
        const cursor = reset ? null : this.state.cursor;
        try {
            const res = await axios.get(API(), { params: cursor ? { cursor } : {} });
            if (res.data.status !== 'OK') return toast.warning(res.data.message || 'Không tải được danh sách');
            const { content, cursor: next } = res.data.data;
            this.setState(s => ({
                bots: (reset ? [] : s.bots).concat(content),
                cursor: next,
                hasMore: next && next !== 'END',
            }));
        } catch (e) {
            toast.error('Không tải được danh sách. Vui lòng thử lại.');
        }
    };

    lookup = async (e) => {
        e.preventDefault();
        const uid = this.state.uid.trim();
        if (!uid) return;
        this.setState({ loading: true, account: null });
        try {
            const res = await axios.get(API() + '/lookup', { params: { uid } });
            if (res.data.status === 'OK') this.setState({ account: res.data.data });
            else toast.warning(res.data.message || 'Không tìm thấy tài khoản');
        } catch (err) {
            toast.error('Tra tài khoản thất bại. Vui lòng thử lại.');
        } finally {
            this.setState({ loading: false });
        }
    };

    setIsBot = async (uid, isBot) => {
        if (this.state.loading) return;
        this.setState({ loading: true });
        try {
            const res = await axios.post(API(), { uid: String(uid), isBot });
            if (res.data.status !== 'OK') return toast.warning(res.data.message || 'Cập nhật thất bại');
            toast.success(res.data.message);
            const updated = res.data.data;
            this.setState(s => ({
                account: s.account && s.account.id === updated.id ? updated : s.account,
                bots: isBot
                    ? [updated].concat(s.bots.filter(b => b.id !== updated.id))
                    : s.bots.filter(b => b.id !== updated.id),
            }));
        } catch (e) {
            toast.error('Cập nhật thất bại. Vui lòng thử lại.');
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { uid, account, bots, hasMore, loading } = this.state;
        return (
            <div id="content">
                <div className="container">
                    <h1 className="text-center">Chặn auto click (isBot)</h1>
                    <p className="text-muted text-center">
                        Nick bị set bot không nhận được mưa quà, thưởng nhiệm vụ, lì xì icoin và quà may mắn.
                    </p>

                    <form className="form-inline justify-content-center my-3" onSubmit={this.lookup}>
                        <input className="form-control mr-2" placeholder="Nhập uid" value={uid}
                               onChange={e => this.setState({ uid: e.target.value })} />
                        <button className="btn btn-primary" type="submit" disabled={loading}>Tra</button>
                    </form>

                    {account && (
                        <div className="card mx-auto mb-4" style={{ maxWidth: 480 }}>
                            <div className="card-body d-flex align-items-center">
                                {account.profileImageLink && (
                                    <img src={account.profileImageLink} alt="" width={56} height={56}
                                         className="rounded-circle mr-3" style={{ objectFit: 'cover' }} />
                                )}
                                <div className="flex-grow-1">
                                    <div><strong>{account.name}</strong> · uid {account.uid}</div>
                                    <div className={account.isBot ? 'text-danger' : 'text-success'}>
                                        {account.isBot ? 'Đang bị set bot' : 'Không phải bot'}
                                    </div>
                                </div>
                                {account.isBot
                                    ? <button className="btn btn-success" disabled={loading}
                                              onClick={() => this.setIsBot(account.uid || account.id, false)}>Gỡ bot</button>
                                    : <button className="btn btn-danger" disabled={loading}
                                              onClick={() => this.setIsBot(account.uid || account.id, true)}>Set bot</button>}
                            </div>
                        </div>
                    )}

                    <h5>Danh sách nick đang bị set bot</h5>
                    <table className="table table-hover">
                        <thead>
                            <tr><th>uid</th><th>Tên</th><th>Ngày tạo nick</th><th></th></tr>
                        </thead>
                        <tbody>
                            {bots.map(b => (
                                <tr key={b.id}>
                                    <td>{b.uid}</td>
                                    <td>{b.name}</td>
                                    <td>{b.addTime ? new Date(b.addTime).toLocaleDateString('vi-VN') : ''}</td>
                                    <td className="text-right">
                                        <button className="btn btn-sm btn-outline-success" disabled={loading}
                                                onClick={() => this.setIsBot(b.uid || b.id, false)}>Gỡ</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {hasMore && (
                        <div className="text-center mb-4">
                            <button className="btn btn-outline-primary" onClick={() => this.loadBots()}>Tải thêm</button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
